import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home'
import artists from '@/pages/artists'
import artist from '@/pages/artist'
import music from '@/pages/music'
import release from '@/pages/release'
import events from '@/pages/events'
import news from '@/pages/news'
import about from '@/pages/about'
import podcast from '@/pages/podcast'
import contact from '@/pages/contact'
import videos from '@/pages/videos'
import submission from '@/pages/submission'
import fourohfour from '@/pages/404'
import booking from '@/pages/booking'
import contest from '@/pages/contest'
import thankyou from '@/pages/thankyou'
import contestSubmission from '@/pages/contest-submission'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/music',
      name: 'music',
      component: music
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/videos',
      name: 'videos',
      component: videos
    },
    {
      path: '/release/:id',
      name: 'release',
      component: release
    },
    {
      path: '/artist/:id',
      name: 'artist',
      component: artist
    },
    {
      path: '/artists',
      name: 'artists',
      component: artists
    },
    {
      path: '/thankyou',
      name: 'thankyou',
      component: thankyou
    },
    {
      path: '/contest',
      name: 'contest',
      component: contest
    },
    {
      path: '/contest-submission',
      name: 'contestSubmission',
      component: contestSubmission
    },
    {
      path: '/submission',
      name: 'submission',
      component: submission
    },
    {
      path: '/events',
      name: 'events',
      component: events
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/podcast',
      name: 'podcast',
      component: podcast
    },
    {
      path: '/booking',
      name: 'booking',
      component: booking
    },
    {
      path: '/:catchAll(.*)',
      name: 'fourohfour',
      component: fourohfour
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js